import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const initiatePallet = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/pallet/initiate?${param}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListPallet = async (token, refresh_token, param, id, fixedParam, dispatch) => {
    const url = `${GROLOG_URL}/pallet?${param}&filter=depot_id eq ${id}&${fixedParam}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const postPallet = async (token, refresh_token, data, fixedParam, dispatch) => {
    const url = `${GROLOG_URL}/pallet?&${fixedParam}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const deletePallet = async (token, refresh_token, id, updated_at, fixedParam, dispatch) => {
    const url = `${GROLOG_URL}/pallet/${id}?${fixedParam}`
    let result = { data: undefined, ok: false }

    let data = {
        'updated_at': updated_at
    }

    try {
        const response = await doDelete(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const editPallet = async (token, refresh_token, id, data, fixedParam, dispatch) => {
    const url = `${GROLOG_URL}/pallet/${id}?${fixedParam}`
    let result = { data: undefined, ok: false }

    try {
        const response = await doPut(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
} 

export const getDetailPallet = async (token, refresh_token, id, fixedParam, dispatch) => {
    const url = `${GROLOG_URL}/pallet/${id}?${fixedParam}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        console.log(error)
    }
    return result
}

export const getSearchRecommendation = async (token, refresh_token, depot_id, keyword, dispatch) =>{
    const url = `${GROLOG_URL}/pallet/search?page=1&limit=10&filter=depot_id eq ${depot_id}, pallet_name lk ${keyword}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSearchResult = async (token, refresh_token, depot_id, keyword, dispatch) =>{
    const url = `${GROLOG_URL}/pallet?page=1&limit=10&filter=depot_id eq ${depot_id}, pallet_name lk ${keyword}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListPalletDropdown = async (token, page, keyword, refresh_token, dispatch) => {
    const params = {
        page: page,
        limit: 10,
        order: 'id asc',
        filter: keyword !== '' ? `depot_name lk ${keyword}` : ''
    }
    const url = `${GROLOG_URL}/depot-list-filter`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, params);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
    const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq pallet, primary_key eq ${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}